import { RootState } from "@store/index";
import { Submission, UserOnboarding } from "types/userTypes";

// Basic user selector
export const selectUser = (state: RootState) => state.user;

// Individual selectors
export const selectIsLoggedIn = (state: RootState): boolean => state.user.loggedIn;
export const selectUserRole = (state: RootState): string => state.user.role;
export const selectUserOrgId = (state: RootState): string => state.user.orgId;
export const selectUserIsActive = (state: RootState): boolean => state.user.isActive;
export const selectUserDistributorId = (state: RootState): string | null => state.user.distId;
export const selectUserReceivedRequests = (state: RootState): Submission[] | null =>
  state.user.receivedRequests;
export const selectUserForcePassChange = (state: RootState): boolean => state.user.forcePassChange;
// Rehydrated sessions from before this field existed carry no `onboarding` key.
export const selectUserOnboarding = (state: RootState): UserOnboarding | null =>
  state.user.onboarding ?? null;
